import SystemShareLine from './system-share-line.component.js'

export * from './system-share-line.component.js'
export default SystemShareLine

SystemShareLine.define()

declare global {
  interface HTMLElementTagNameMap {
    'dap-ds-icon-share-line': SystemShareLine
  }
}
